import Header from "components/Headers/Header";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  Card,
  Container,
  Modal,
  ModalBody,
  Nav,
  NavItem,
  NavLink,
  Row,
  Spinner,
  TabContent,
  TabPane,
} from "reactstrap";
import {
  getTotalAmount,
  getOtherWalletTransaction,
  getOnlyWalletTransaction,
  getApprovedContracts,
} from "store/actions/ContractRequestsAction";
import TableComponent from "components/TableComponent";
import TabsInfoModal from "components/Modal/TabsInfoModal";

const ApprovedSchools = () => {
  let dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const [id, setId] = useState("");
  const [loader, setLoader] = useState({
    mainData: true,
    modalData: false,
    loadMore: false,
  });
  const {
    approvedContracts,
    walletTransaction,
    otherTransaction,
    totalWalletAmount,
    walletMoreData,
    walletLastDocument,
    otherMoreData,
    otherLastDocument,
    contractLastDocument,
    contractHasMore,
  } = useSelector((state) => state.ContractRequest);
  const [activeTab, setActiveTab] = useState("regularWalt");
  const infoPoints = [
    "In this module, the admin can view the total number of approved school users. An action button is provided in the table, allowing the admin to view each user's total earnings.",
  ];
  const subPoints = [];
  const infoTitle = "Approved School Information";
  const [infoModalOpen, setInfoModalOpen] = useState(false);

  const mainColumns = ["Email", "Name", "Created At"];
  const mainKeyMap = {
    Email: "email",
    Name: "name",
    "Created At": "created_at",
  };

  const formattedMainData = approvedContracts.map((item) => ({
    ...item,
    name: item.name || "No Add Name",
    created_at: moment.unix(item?.created_at?.seconds).format("MMMM Do YYYY"),
  }));

  const walletColumns = ["Type", "Amount", "Day", "Athlete Email"];
  const walletKeyMap = {
    Type: "paymentType",
    Amount: "amount",
    Day: "createdAt",
    "Athlete Email": "athleteEmail",
  };

  const formattedWalletData = walletTransaction.map((item) => ({
    paymentType: item.data.paymentType,
    amount: `${item.data.amount}$`,
    createdAt: moment.unix(item.data.createdAt.seconds).format("MMM-DD-YYYY"),
    athleteEmail: item.athlete.email,
  }));

  const formattedOtherData = otherTransaction.map((item) => ({
    paymentType: item.data.paymentType,
    amount: `${item.data.amount}$`,
    createdAt: moment.unix(item.data.createdAt.seconds).format("MMM-DD-YYYY"),
    athleteEmail: item.athlete.email,
  }));

  const toggle = () => {
    setActiveTab("regularWalt");
    setIsOpen(!isOpen);
  };

  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  const renderMainActions = (row) => (
    <Button
      color="primary"
      size="sm"
      className="border-0"
      onClick={() => {
        toggle();
        getWaltData(row.id);
      }}
    >
      <i className="fas fa-solid fa-eye"></i>
    </Button>
  );

  useEffect(() => {
    if (
      activeTab === "topUp" &&
      (!otherTransaction || otherTransaction?.length == 0)
    ) {
      setLoader((prev) => ({ ...prev, modalData: true }));
      dispatch(
        getOtherWalletTransaction(id, "", () => {
          setLoader((prev) => ({ ...prev, modalData: false }));
        })
      );
    }
  }, [activeTab]);

  useEffect(() => {
    dispatch(
      getApprovedContracts("", () => {
        setLoader((prev) => ({ ...prev, mainData: false }));
      })
    );
  }, []);

  const LoadMoreApprovedContracts = () => {
    setLoader((prev) => ({ ...prev, loadMore: true }));
    dispatch(
      getApprovedContracts(contractLastDocument, () => {
        setLoader((prev) => ({ ...prev, loadMore: false }));
      })
    );
  };

  const getWaltData = (id) => {
    setId(id);
    setLoader((prev) => ({ ...prev, modalData: true }));
    dispatch(getTotalAmount(id));
    dispatch(
      getOnlyWalletTransaction(id, "", () => {
        setLoader((prev) => ({ ...prev, modalData: false }));
      })
    );
  };

  const walletLoadMore = () => {
    setLoader((prev) => ({ ...prev, loadMore: true }));
    dispatch(
      getOnlyWalletTransaction(id, walletLastDocument, () => {
        setLoader((prev) => ({ ...prev, loadMore: false }));
      })
    );
  };

  const otherWalletLoadMore = () => {
    setLoader((prev) => ({ ...prev, loadMore: true }));
    dispatch(
      getOtherWalletTransaction(id, otherLastDocument, () => {
        setLoader((prev) => ({ ...prev, loadMore: false }));
      })
    );
  };

  return (
    <>
      <Header />
      <Container fluid>
        <Row>
          <h2
            className="mb-0 ml-auto m-2 text-primary"
            style={{ cursor: "pointer" }}
            onClick={() => setInfoModalOpen(true)}
          >
            <i className="fa fa-question-circle" aria-hidden="true"></i>
          </h2>{" "}
        </Row>

        <Card className="pb-2">
          {loader.mainData ? (
            <div className="text-center">
              <Spinner color="primary" />
            </div>
          ) : (
            <TableComponent
              columns={mainColumns}
              data={formattedMainData}
              keyMap={mainKeyMap}
              renderActions={renderMainActions}
            />
          )}
          {approvedContracts.length > 4 && (
            <div className="text-center py-4">
              <Button
                onClick={LoadMoreApprovedContracts}
                color="primary"
                disabled={loader.loadMore || !contractHasMore}
              >
                {loader.loadMore ? <Spinner size="sm" /> : "Load More"}
              </Button>
            </div>
          )}
        </Card>
      </Container>
      <TabsInfoModal
        setInfoModalOpen={setInfoModalOpen}
        infoModalOpen={infoModalOpen}
        data={infoPoints}
        title={infoTitle}
        subPoints={subPoints}
      />
      <Modal isOpen={isOpen} toggle={toggle} size="lg" centered>
        <ModalBody>
          <h2 className="text-center modal-title-text">
            Total wallet amount : $
            {(
              (totalWalletAmount.topupAmount ?? 0) +
              (totalWalletAmount.amount ?? 0)
            ).toFixed(2)}
          </h2>
          <div className="d-flex flex-column flex-sm-row justify-content-between my-2">
            <h2 className="text-center mb-2 mb-sm-0 modal-title-text">
              Top up amount : ${(totalWalletAmount.topupAmount ?? 0).toFixed(2)}
            </h2>
            <h2 className="text-center mb-2 mb-sm-0 modal-title-text">
              Regular amount : ${(totalWalletAmount.amount ?? 0).toFixed(2)}
            </h2>
          </div>
          <Card>
            <Nav
              tabs
              className="d-flex justify-content-start text-dark athlete_earning-nav"
            >
              <NavItem>
                <NavLink
                  className={
                    activeTab === "regularWalt"
                      ? "active active-tab py-2 bg-primary"
                      : "text-dark cursor-pointer py-2"
                  }
                  onClick={() => toggleTab("regularWalt")}
                >
                  <h2
                    className={activeTab === "regularWalt" ? "text-white" : ""}
                  >
                    Regular walt
                  </h2>
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={
                    activeTab === "topUp"
                      ? "active active-tab py-2 bg-primary"
                      : "text-dark cursor-pointer py-2"
                  }
                  onClick={() => toggleTab("topUp")}
                >
                  <h2 className={activeTab === "topUp" ? "text-white" : ""}>
                    Top up
                  </h2>
                </NavLink>
              </NavItem>
            </Nav>
            <TabContent
              activeTab={activeTab}
              className="p-3 athlete-earning-content"
            >
              <TabPane tabId="regularWalt">
                {loader.modalData ? (
                  <div className="text-center">
                    <Spinner color="primary" />
                  </div>
                ) : (
                  <TableComponent
                    columns={walletColumns}
                    data={formattedWalletData}
                    keyMap={walletKeyMap}
                  />
                )}
                {walletTransaction.length > 9 && (
                  <div className="text-center">
                    <Button
                      color="primary"
                      size="sm"
                      onClick={walletLoadMore}
                      disabled={!walletMoreData || loader.loadMore}
                    >
                      {loader.loadMore ? (
                        <Spinner size="sm" color="white" />
                      ) : (
                        "Load more"
                      )}
                    </Button>
                  </div>
                )}
              </TabPane>
              <TabPane tabId="topUp">
                {loader.modalData ? (
                  <div className="text-center">
                    <Spinner color="primary" />
                  </div>
                ) : (
                  <TableComponent
                    columns={walletColumns}
                    data={formattedOtherData}
                    keyMap={walletKeyMap}
                  />
                )}
                {otherTransaction.length > 9 && (
                  <div className="text-center">
                    <Button
                      color="primary"
                      size="sm"
                      onClick={otherWalletLoadMore}
                      disabled={!otherMoreData || loader.loadMore}
                    >
                      {loader.loadMore ? (
                        <Spinner size="sm" color="white" />
                      ) : (
                        "Load more"
                      )}
                    </Button>
                  </div>
                )}
              </TabPane>
            </TabContent>
          </Card>
          <div className="text-right mt-2">
            <Button color="danger" size="sm" onClick={toggle}>
              Close
            </Button>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default ApprovedSchools;
